import React, {useEffect, useState} from 'react';
import {api} from '../api';
import PageLoadingIndicator from './Layout/PageLoadingIndicator';

import load from '../lib/load';
import CallForPapers from './CallForPapers';
import {useParams} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import Header from './Layout/Header';
import {isAuthenticated} from '../auth';
import LoginPrompt from '../auth/LoginPrompt';
import {useIntl} from 'react-intl';
import {CallForPapersVersionBanner} from './CallForPapersVersionBanner';

const CallForPapersContainer = () => {

    const intl = useIntl();
    const {slug} = useParams();

    const [callForPapers, setCallForPapers] = useState();
    const [roles, setRoles] = useState();

    useEffect(() => {
        const fetchData = async () => {
            const c4p = await api.fetchCallForPapers(slug);
            const [roles] = await Promise.all([
                api.fetchRoles(c4p.id),
                // TODO das darf nur im Kontext des C4P applied werden, sonst soll wieder Standard genommen werden
                load.css(`${process.env.REACT_APP_API_BASE_URL}pco/callforpapers/${c4p.id}/styling`)
            ]);

            setCallForPapers(c4p);
            setRoles(roles);
        }

        fetchData();
    }, [slug])

    /**
     * Komponente ist zur Anzeige bereit, wenn CallForPapers und falls notwndig die Einreichung geladen wurden.
     */
    function isReady() {
        return callForPapers;
    }

    if (!isReady()) {
        return <PageLoadingIndicator/>;
    }

    return (
        <>
            <Helmet>
                <title>Leipziger Messe - {callForPapers.publicName[intl.locale]}</title>
            </Helmet>
            <Header enabledLanguages={callForPapers.enabledLanguages}/>
            {!callForPapers.isPublishedVersion && <CallForPapersVersionBanner/>}
            {isAuthenticated()
                ? <CallForPapers callForPapers={callForPapers} roles={roles}/>
                : <LoginPrompt/>
            }
        </>
    );
}

export default CallForPapersContainer;
